



























































































































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import fieldData from "@/ts/FormData";
import { IVueStateCollection } from "@/ts/FormBuilder";
import ErrorMessages from "@/ts/constants/ReportingErrorMessages";
import { IMaterialItemVueModel } from "@/ts/models/IMaterialItemVueModel";
import { IResidentialHaulerVueModel } from "@/ts/models/IResidentialHaulerVueModel";

@Component({
    props: {
        form: {
            type: Object as () => IResidentialHaulerVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    }
})
export default class ResidentialHaulerMaterials extends Vue {
    name: string = "ResidentialHaulerMaterials";
    title: string = "";

    errorMsgs = ErrorMessages;
    unitsOfMeasure = fieldData.unitsOfMeasureReport;

    mounted(): void {
        this.title = this.$props.vueStates.views[1].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", 1);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[1].error = this.hasErrors;
        }, { immediate: true });

        this.$props.vueStates.views[1].visited = true;

        if (this.$props.form.materials.length === 0) {
            this.$props.form.materials = fieldData.reportingMaterials.residentialHauler;
        }
    }

    get hasUserMaterialErrors(): boolean {
        let materials = this.$props.form.userMaterials as IMaterialItemVueModel[];
        return materials.some((m, ix, arr) => this.isUserMaterialError(ix));
    }

    get hasMaterialErrors(): boolean {
        if (this.$props.form.materials.length == 0) {
            return true;
        }
        let materials = this.$props.form.materials as IMaterialItemVueModel[];
        return materials.some((m, ix, arr) => this.isMaterialError(ix));
    }

    isMaterialNameError(index: number): boolean {
        if (this.$props.form.userMaterials.length == 0 || index >= this.$props.form.userMaterials.length) {
            return false;
        }
        return func.isNullOrEmpty(this.$props.form.userMaterials[index].name);
    }

    isMaterialAmountError(index: number): boolean {
        if (this.$props.form.materials.length == 0 || index >= this.$props.form.materials.length) {
            return false;
        }
        return func.isNullOrEmpty(this.$props.form.materials[index].amount) || this.$props.form.materials[index].amount < 0;
    }

    isUserMaterialAmountError(index: number): boolean {
        if (this.$props.form.userMaterials.length == 0 || index >= this.$props.form.userMaterials.length) {
            return false;
        }
        return func.isNullOrEmpty(this.$props.form.userMaterials[index].amount) || this.$props.form.userMaterials[index].amount <= 0;
    }

    isMaterialMeasureError(index: number): boolean {
        if (this.$props.form.userMaterials.length == 0 || index >= this.$props.form.userMaterials.length) {
            return false;
        }
        return func.isNullOrEmpty(this.$props.form.userMaterials[index].measure);
    }

    private isMaterialError(index: number): boolean {
        if (this.$props.form.materials.length == 0 || index >= this.$props.form.materials.length) {
            return false;
        }
        return this.isMaterialNameError(index) || this.isMaterialAmountError(index) || this.isMaterialMeasureError(index);
    }

    private isUserMaterialError(index: number): boolean {
        if (this.$props.form.userMaterials.length == 0 || index >= this.$props.form.userMaterials.length) {
            return false;
        }
        return this.isMaterialNameError(index) || this.isUserMaterialAmountError(index) || this.isMaterialMeasureError(index);
    }

    addUserMaterial(): void {
        this.$props.form.userMaterials.push(fieldData.reportingMaterials.emptyMaterialItem);
    }

    removeUserMaterial(materialId: string): void {
        let materials = this.$props.form.userMaterials as IMaterialItemVueModel[];
        let index = materials.map((item) => item.id).indexOf(materialId);
        materials.splice(index, 1);
    }

    get hasErrors(): boolean {
        return this.hasUserMaterialErrors || this.hasMaterialErrors;
    }
}
